export enum Periodicity {
    D ='D',
    DA = 'DA',
    DD = 'DD',
    DE = 'DE',
    DN = 'DN',
    DQ = 'DQ',
    DT = 'DT',
    DV = 'DV',
    DW = 'DW',
    DX = 'DX',
    DZ = 'DZ',
    J = 'J',
    JD = 'JD',
    JH2 = 'JH2',
    JQ = 'JQ',
    JT = 'JT',
    JV = 'JV',
    JZ = 'JZ',
    M = 'M',
    MA = 'MA',
    MC = 'MC',
    MD = 'MD',
    ME = 'ME',
    MN = 'MN',
    MQ = 'MQ',
    MS = 'MS',
    MT = 'MT',
    MV = 'MV',
    MX = 'MX',
    MZ2 = 'MZ2',
    O1 = 'O1',
    ONDEMAND = 'ondemand',
    U = 'U',
    UA = 'UA',
    UD = 'UD',
    UE = 'UE',
    UH = 'UH',
    UN = 'UN',
    UQ = 'UQ',
    US = 'US',
    UT = 'UT',
    UV = 'UV',
    UW = 'UW',
    UX = 'UX',
    UZ = 'UZ',
    W = 'W',
    WA = 'WA',
    WD = 'WD',
    WE = 'WE',
    WN = 'WN',
    WP = 'WP',
    WQ = 'WQ',
    WS = 'WS',
    WT = 'WT',
    WV = 'WV',
    WW = 'WW',
    WX = 'WX',
    WZ = 'WZ'
}
